import { TerrainItemEntity } from '@src/features/order/pages/upsert-mission-page/entities';

export const analyzeIntervals = (wps: TerrainItemEntity[], terrain: TerrainItemEntity[], buffer: number = 0) => {
  const collisions = [];
  for (let i = 0; i < wps.length - 1; i++) {
    const start = wps[i];
    const end = wps[i + 1];

    const startDist = start.distance;
    const endDist = end.distance;

    const startAlt = Number(start.altitude);
    const endAlt = Number(end.altitude);

    const intervals = terrain.filter((t) => t.distance >= startDist && t.distance <= endDist);

    for (const point of intervals) {
      const terrainDist = point.distance;
      const bufferedAlt = Number(point.altitude) + buffer;

      const totalSegmentDist = endDist - startDist;
      const ratio = totalSegmentDist === 0 ? 0 : (terrainDist - startDist) / totalSegmentDist;

      const droneAlt = startAlt + (endAlt - startAlt) * ratio;

      if (bufferedAlt >= droneAlt) {
        collisions.push({
          idx: terrain.indexOf(point),
          text: `Route Unsafe: At ${terrainDist}m, the drone is ${Math.round(droneAlt - bufferedAlt)}m below terrain level`,
        });
      }
    }
  }

  return collisions;
};